import React, { useEffect, useState } from 'react';
import { CheckCircle2Icon, ChevronDownIcon, ChevronUpIcon, FacebookIcon, InstagramIcon, LockIcon, MailIcon, ShieldCheckIcon, XCircleIcon, ZapIcon } from 'lucide-react';
const CHECKOUT_URL = 'https://cupping-estetico.impultienda.ar/checkout';
const faqs = [['¿Sirve si recién estoy empezando con ventosas estéticas?', 'Sí. Cada protocolo está explicado paso a paso, desde la anatomía de la zona hasta el movimiento exacto. No necesitás experiencia previa con ventosas para empezar a aplicar los tomos desde el día uno.'], ['¿Sirve si ya soy esteticista con experiencia?', 'Especialmente. El MegaPack Ventosas Estéticas Pro™ te da la estructura profesional y el material de cabina que probablemente te faltaba: fichas, checklists, mapas de zonas y protocolos avanzados que podés incorporar a tus sesiones actuales de inmediato.'], ['¿Cómo recibo el material?', 'Descarga inmediata en PDF apenas confirmás la compra. Lo abrís en computadora, tablet o celular, y podés imprimir todo lo que necesites para tu cabina.'], ['¿Qué ventosas necesito tener para usar los protocolos?', 'El Bono 01 incluye el Mapa Express de Ventosas por Zona con las especificaciones de tamaño e intensidad para cada protocolo. No necesitás un kit costoso para empezar.'], ['¿El material está en español neutro?', 'Sí. Todo el sistema está escrito en español neutro para que sea útil para esteticistas de Argentina, México, Colombia, España, Chile, Venezuela, Perú y todo el mundo hispanohablante.'], ['¿Puedo usar el material con mi marca?', 'Las fichas de evaluación y el material de seguimiento están diseñados para que les agregues tu logo y los uses como material profesional de tu cabina.'], ['¿Esto es un curso con clases en video?', 'No. Es un sistema completo en PDF listo para usar. Abrís el tomo, elegís el protocolo y lo aplicás. Cero teoría de relleno.'], ['¿Y si no me sirve?', 'Garantía de 7 días con devolución total, sin preguntas.']];
const valueRows = [['Sesiones sin protocolo estructurado', 'Resultados inconsistentes — clientas que no vuelven', 'Protocolos claros por zona', 'Resultados visibles — clientas que vuelven y refieren'], ['Técnica improvisada por zona', 'Confianza baja — precio bajo', 'Técnica estructurada paso a paso', 'Confianza alta — precio que se justifica solo'], ['Buscar tutoriales en YouTube', 'Información contradictoria, en inglés o sin base técnica', 'Sistema completo en español', 'Información técnica, probada y lista para usar'], ['Sin diferenciación de la competencia', 'Tu cabina se ve igual que todas las demás', 'Material profesional de cabina', 'Tu servicio se percibe premium desde el primer momento'], ['Sin justificación para cobrar más', 'Seguís cobrando lo mismo hace años', 'Metodología de 6 tomos', 'Tenés el respaldo para cobrar lo que realmente valés'], ['Sin material profesional de seguimiento', 'La clienta no ve su progreso y abandona', 'Fichas de seguimiento y agenda', 'La clienta ve su evolución y renueva']];
const costRows = [['Sesiones sin estructura clara', 'Clientas que no ven resultados y no vuelven — perdés $80 a $200 por clienta'], ['Sin diferenciación profesional', 'Siempre compitiendo por precio con quien cobra menos'], ['Sin material de cabina premium', 'Tu servicio parece igual al de cualquier otra esteticista'], ['Sin protocolos avanzados', 'Nunca podés justificar subir tus precios'], ['Sin sistema de seguimiento', 'La clienta no ve su progreso y abandona antes de tiempo']];
const testimonials = [['El Tomo V es el que más me pidieron mis clientas. El Brazilian Lift con ventosas es ahora el tratamiento estrella de mi cabina. Lista de espera de tres semanas.', 'Esteticista certificada · Colombia'], ['Las fichas de seguimiento cambiaron la percepción de mis clientas. Ahora ven su progreso documentado. Tres de cada cuatro renuevan el tratamiento.', 'Cosmetóloga · Chile'], ['Compré el MegaPack Ventosas Estéticas Pro™ un viernes. El lunes ya apliqué el protocolo de drenaje linfático. Mi clienta me preguntó qué había cambiado. Le dije: mi método.', 'Esteticista independiente · España'], ['Lo que más uso antes de cada sesión es el Mapa Express de Ventosas. En 30 segundos ya sé qué usar. Eso solo ya vale el precio completo.', 'Masajista estética · México'], ['Subí mis precios tres semanas después de empezar a usar los protocolos. Mis clientas no solo no se quejaron — me felicitaron por el nivel del servicio.', 'Esteticista · Venezuela'], ['El protocolo de cuello del Tomo II es el que más wow genera. Las clientas se miran al espejo y no lo pueden creer. Eso es lo que hace que vuelvan.', 'Terapeuta estética · Perú']];
export function Pricing() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 34
  });
  const [openFaq, setOpenFaq] = useState<number | null>(0);
  useEffect(() => {
    const timer = window.setInterval(() => {
      setTimeLeft(current => {
        if (current.seconds) return {
          ...current,
          seconds: current.seconds - 1
        };
        if (current.minutes) return {
          ...current,
          minutes: current.minutes - 1,
          seconds: 59
        };
        if (current.hours) return {
          hours: current.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return current;
      });
    }, 1000);
    return () => window.clearInterval(timer);
  }, []);
  const clock = `${String(timeLeft.hours).padStart(2, '0')}:${String(timeLeft.minutes).padStart(2, '0')}:${String(timeLeft.seconds).padStart(2, '0')}`;
  return <div className="w-full bg-cream" data-id="element-118" data-mp="1523z9su9totg">
      <section className="bg-brand-900 px-4 py-11 text-center text-white sm:px-6" aria-label="Oferta de lanzamiento" data-id="element-119" data-mp="14yzk60f9p8o0">
        <p className="text-xs font-black tracking-[0.12em] text-accent" data-id="element-120" data-mp="1erf7zed8wrgt">
          🛑 PRECIO DE LANZAMIENTO — CIERRA EN:
        </p>
        <p aria-live="polite" className="mt-3 font-mono text-4xl font-black tracking-tight text-white sm:text-6xl" data-id="element-121" data-mp="19z43rzbh2jig">
          {clock}
        </p>
        <p className="mt-3 text-sm text-gray-300" data-id="element-122" data-mp="1jp6yq525m7jf">
          ⚠️ Después sube a $37. No vuelve.
        </p>
        <div className="mx-auto mt-5 h-2 max-w-md overflow-hidden rounded-full bg-brand-800" data-id="element-123" data-mp="1xoorswmhg6yl">
          <div className="h-full w-[91%] rounded-full bg-accent" data-id="element-124" data-mp="1ss823xzmxkje" />
        </div>
        <p className="mt-2 text-xs text-brand-100" data-id="element-125" data-mp="3b6zkwb4ulx8">
          El 91% de los accesos al precio de lanzamiento ya fueron reservados
        </p>
      </section>

      <section id="pricing" className="mx-auto max-w-6xl scroll-mt-4 px-4 py-12 sm:px-6 md:py-20" data-id="element-126" data-mp="3ukmfqkv5c2u0">
        <div className="text-center" data-id="element-127" data-mp="2ez2d1gpdbae9">
          <p className="text-xs font-bold uppercase tracking-[0.16em] text-brand-600" data-id="element-128" data-mp="2ey0rujen17it">
            Tu MegaPack Ventosas Estéticas Pro™ completo
          </p>
          <h2 className="mt-3 text-3xl font-black text-brand-900 md:text-4xl" data-id="element-129" data-mp="259930k4vj3c4">
            Todos tus protocolos de ventosas resueltos
          </h2>
        </div>
        <div className="mx-auto mt-9 max-w-2xl" data-id="element-130" data-mp="1r8g7px6r047y">
          <article className="flex flex-col rounded-2xl border border-brand-100 bg-white p-6 text-center shadow-sm md:p-8" data-id="element-131" data-mp="1w946j517xpcq">
            <p className="text-xs font-black tracking-[0.14em] text-brand-600" data-id="element-132" data-mp="1hcv7a3hbvc0b">
              MEGAPACK VENTOSAS ESTÉTICAS PRO™ — SISTEMA COMPLETO
            </p>
            <h3 className="mt-2 text-2xl font-black text-brand-900" data-id="element-133" data-mp="3bpulpt9z2060">
              6 Tomos + 5 Bonos
            </h3>
            <p className="mt-2 text-sm text-gray-600" data-id="element-134" data-mp="3goxmh1ix5k86">
              Todos tus protocolos de ventosas resueltos.
            </p>
            <ul className="mt-6 space-y-3 text-left text-sm text-gray-700" data-id="element-135" data-mp="24esrp0zrh6cj">
              {['6 tomos completos con 360+ páginas', '5 bonos estratégicos incluidos', 'Protocolos, fichas y checklists imprimibles'].map(item => <li key={item} className="flex gap-2" data-id="element-136" data-mp="1ppwnxg4qmfhq">
                  <CheckCircle2Icon className="h-5 w-5 shrink-0 text-brand-500" data-id="element-137" data-mp="1kruuc19oqxs0" />
                  {item}
                </li>)}
            </ul>
            <div className="mt-7 text-center" data-id="element-138" data-mp="1gruhum65cwnl">
              <p data-id="element-139" data-mp="1bpvcj6qujpo0">
                <span className="mr-2 text-lg text-gray-400 line-through" data-id="element-140" data-mp="1brg7gxh2pame">
                  $37 USD
                </span>
                <strong className="font-black text-brand-900 text-[80px]" data-id="element-141" data-mp="16ten897wv59c">
                  $14
                </strong>{' '}
                <span className="font-bold text-brand-600" data-id="element-142" data-mp="315lcgbxn3mkn">USD</span>
              </p>
              <p className="mt-1 text-xs text-gray-500" data-id="element-143" data-mp="313s48s7douaj">
                El producto se cobrará en moneda local.
              </p>
            </div>
            <a href={CHECKOUT_URL} className="mt-5 block rounded-xl border-2 border-brand-600 px-4 py-3.5 text-center text-sm font-extrabold text-brand-700 transition-colors hover:bg-brand-50" data-id="element-144" data-mp="3dnff1kmzd4on">
              SÍ, QUIERO MI MEGAPACK VENTOSAS ESTÉTICAS PRO™
            </a>
            <p className="mt-4 flex flex-wrap justify-center gap-x-3 gap-y-1 text-xs text-gray-500" data-id="element-145" data-mp="2prjncmsc8vvb">
              <span className="flex items-center gap-1" data-id="element-146" data-mp="2uq4ezxtiy785">
                <LockIcon className="h-3.5 w-3.5" data-id="element-147" data-mp="2zopcvqlb0etf" />
                Pago seguro
              </span>
              <span className="flex items-center gap-1" data-id="element-148" data-mp="34n93w5er8gsn">
                <ZapIcon className="h-3.5 w-3.5" data-id="element-149" data-mp="34otyfv12jzqi" />
                Acceso inmediato
              </span>
              <span className="flex items-center gap-1" data-id="element-150" data-mp="exx7j6r6wslc">
                <ShieldCheckIcon className="h-3.5 w-3.5" data-id="element-151" data-mp="jwi9bam3bkbw" />
                Garantía de 7 días
              </span>
            </p>
          </article>
        </div>
      </section>

      <section className="bg-white px-4 py-12 sm:px-6 md:py-20" data-id="element-152" data-mp="391pe64whztmc">
        <div className="mx-auto max-w-6xl" data-id="element-153" data-mp="38zural1o1rfm">
          <div className="text-center" data-id="element-154" data-mp="3ds5txvnsjrbv">
            <p className="text-xs font-bold uppercase tracking-[0.16em] text-brand-600" data-id="element-155" data-mp="3dtfs0kun8zii">
              Comparativa de valor
            </p>
            <h2 className="mt-3 text-3xl font-black text-brand-900 md:text-4xl" data-id="element-156" data-mp="2m1rhm3vfen2b">
              💸 ¿Cuánto cuesta seguir sin un sistema?
            </h2>
          </div>
          <div className="mt-9 overflow-x-auto rounded-xl border border-brand-100" data-id="element-157" data-mp="2q55ysxv3p9hc">
            <table className="min-w-[840px] w-full text-left text-sm" data-id="element-158" data-mp="2v0ldfs0xn9et">
              <thead data-id="element-159" data-mp="302ao36k8tl2d">
                <tr className="bg-cream" data-id="element-160" data-mp="302u5mm5ze7fv">
                  <th colSpan={2} className="border-r border-brand-100 p-4 text-brand-900" data-id="element-161" data-mp="abxi87vb9ifg">
                    ❌ Sin MegaPack Ventosas Estéticas Pro™
                  </th>
                  <th colSpan={2} className="p-4 text-brand-700" data-id="element-162" data-mp="1zs17kti402hf">
                    ✅ Con MegaPack Ventosas Estéticas Pro™
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-163" data-mp="1q2hphq280cnm">
                {valueRows.map(([without, cost, withSystem, result]) => <tr key={without} className="border-t border-brand-100" data-id="element-164" data-mp="1l4yceth9e5x9">
                    <td className="p-4 font-semibold text-gray-700" data-id="element-165" data-mp="1h2l35v3azpvq">
                      {without}
                    </td>
                    <td className="border-r border-brand-100 p-4 text-gray-500" data-id="element-166" data-mp="1c38ingzwmuwb">
                      {cost}
                    </td>
                    <td className="p-4 font-semibold text-brand-800" data-id="element-167" data-mp="174nkdn47qlai">
                      {withSystem}
                    </td>
                    <td className="p-4 text-brand-700" data-id="element-168" data-mp="31ig2g50iriu4">{result}</td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-6xl px-4 py-12 sm:px-6 md:py-20" data-id="element-169" data-mp="2whipc6ud9ezh">
        <div className="text-center" data-id="element-170" data-mp="usuvushdfjej">
          <p className="text-xs font-bold uppercase tracking-[0.16em] text-brand-600" data-id="element-171" data-mp="zkmduemgogt2">
            Más testimonios
          </p>
          <h2 className="mt-3 text-3xl font-black text-brand-900 md:text-4xl" data-id="element-172" data-mp="kx1bwo1bonmq">
            Una nueva forma de trabajar se nota
          </h2>
        </div>
        <div className="mt-9 grid gap-4 sm:grid-cols-2 md:grid-cols-3" data-id="element-173" data-mp="psqhb800wyqy">
          {testimonials.map(([quote, role]) => <article key={quote} className="rounded-xl border border-brand-100 bg-white p-5" data-id="element-174" data-mp="1ika3n0rx2sx6">
              <p className="text-xs font-bold text-accent" data-id="element-175" data-mp="14jfs499kobua">★★★★★</p>
              <blockquote className="mt-2 text-sm leading-relaxed text-gray-700" data-id="element-176" data-mp="18l19a6t53caa">
                “{quote}”
              </blockquote>
              <p className="mt-4 text-xs font-bold text-brand-700" data-id="element-177" data-mp="3p8n2j2dgmd3z">{role}</p>
            </article>)}
        </div>
        <p className="mt-5 text-center text-xs text-gray-500" data-id="element-178" data-mp="3t9p4vs2ob5a6">
          Testimonios de lanzamiento. Se reemplazarán por opiniones verificadas
          de compradoras.
        </p>
      </section>

      <section className="bg-brand-50 px-4 py-12 sm:px-6" data-id="element-179" data-mp="3gva80vl49jux">
        <div className="mx-auto max-w-3xl rounded-3xl border-2 border-brand-100 bg-white p-7 text-center shadow-sm md:p-10" data-id="element-180" data-mp="3vpf0n7fq4k3d">
          <ShieldCheckIcon className="mx-auto h-12 w-12 text-brand-600" data-id="element-181" data-mp="3qs53t6q0965i" />
          <h2 className="mt-4 text-3xl font-black text-brand-900" data-id="element-182" data-mp="332klmq1oecxa">
            GARANTÍA DE 7 DÍAS — SIN PREGUNTAS
          </h2>
          <p className="mt-4 leading-relaxed text-gray-600" data-id="element-183" data-mp="2y0lgpbqaf7y8">
            Abrí los tomos. Aplicá los protocolos. Mirá los resultados.
          </p>
          <p className="mt-2 leading-relaxed text-gray-600" data-id="element-184" data-mp="380cfhplvs944">
            Si en 7 días no es lo que esperabas: te devolvemos el 100% de tu
            inversión, sin formularios, sin explicaciones y sin complicaciones.
          </p>
          <p className="mt-5 text-sm font-bold text-brand-600" data-id="element-185" data-mp="2fboyi68605wd">
            Porque estamos seguros de lo que entregamos.
          </p>
        </div>
      </section>

      <section className="bg-white px-4 py-12 sm:px-6 md:py-20" data-id="element-186" data-mp="1mlwzs7goklgn">
        <div className="mx-auto max-w-3xl" data-id="element-187" data-mp="1mk2c4le0yf8v">
          <h2 className="text-center text-3xl font-black text-brand-900" data-id="element-188" data-mp="1rl9neufdlwka">
            Preguntas frecuentes
          </h2>
          <div className="mt-8 space-y-3" data-id="element-189" data-mp="1wdsynkqlcflx">
            {faqs.map(([question, answer], index) => {
            const isOpen = openFaq === index;
            return <div key={question} className="overflow-hidden rounded-xl border border-gray-200" data-id="element-190" data-mp="269milp6n3bdq" data-mpi={index}>
                  <button type="button" onClick={() => setOpenFaq(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 bg-cream px-5 py-4 text-left text-sm font-bold text-brand-900" data-id="element-191" data-mp="2aa6fqsr7qezv">
                    {question}
                    {isOpen ? <ChevronUpIcon className="h-5 w-5 shrink-0" data-id="element-192" data-mp="dfd6cixqj0ej" /> : <ChevronDownIcon className="h-5 w-5 shrink-0" data-id="element-193" data-mp="8kqtebc08zsc" />}
                  </button>
                  {isOpen && <div className="bg-white px-5 py-4 text-sm leading-relaxed text-gray-600" data-id="element-194" data-mp="3uutfau2ti7ci">
                      {answer}
                    </div>}
                </div>;
          })}
          </div>
        </div>
      </section>

      <section className="bg-brand-900 px-4 py-12 text-white sm:px-6 md:py-20" data-id="element-195" data-mp="me8cxw4oycid">
        <div className="mx-auto max-w-6xl text-center" data-id="element-196" data-mp="mgbar2c359xn">
          <p className="text-xs font-bold uppercase tracking-[0.16em] text-accent" data-id="element-197" data-mp="iblgfhx2s3eu">
            El costo real de seguir sin un sistema profesional
          </p>
          <h2 className="mt-3 text-3xl font-black md:text-4xl" data-id="element-198" data-mp="332vptkk3f85e">
            💸 ¿Cuánto cuesta no tenerlo?
          </h2>
          <div className="mt-8 overflow-x-auto rounded-xl border border-brand-700 text-left" data-id="element-199" data-mp="34jhxgcrtpyoa">
            <table className="min-w-[650px] w-full text-sm" data-id="element-200" data-mp="39jns81te41al">
              <thead data-id="element-201" data-mp="39h1ipwmxvbpq">
                <tr className="bg-brand-800" data-id="element-202" data-mp="2ulvar44a92tr">
                  <th className="p-4" data-id="element-203" data-mp="2ul2380xi29ak">Sin MegaPack Ventosas Estéticas Pro™</th>
                  <th className="p-4" data-id="element-204" data-mp="2zk591nlb0jjl">Costo real</th>
                </tr>
              </thead>
              <tbody data-id="element-205" data-mp="2lt9vvz3rvga7">
                {costRows.map(([without, cost]) => <tr key={without} className="border-t border-brand-700" data-id="element-206" data-mp="2qk01ndg41l5f">
                    <td className="p-4 text-brand-100" data-id="element-207" data-mp="2qmcpu8cgorqx">{without}</td>
                    <td className="p-4 font-semibold text-white" data-id="element-208" data-mp="2bwotzmn1ulal">{cost}</td>
                  </tr>)}
              </tbody>
            </table>
          </div>
          <p className="mt-8 text-brand-100" data-id="element-209" data-mp="22ufh4q4b6fu1">
            Tu próxima clienta puede vivir una experiencia completamente
            diferente.
          </p>
          <p className="mt-5 font-serif text-2xl italic text-accent" data-id="element-210" data-mp="26ydeava2pgkg">
            “Tu próxima sesión puede ser la mejor que diste.”
          </p>

          <div className="mx-auto mt-10 max-w-4xl rounded-3xl bg-white p-7 text-brand-900 md:p-10" data-id="element-211" data-mp="1j9nokgj09hlw">
            <h3 className="text-3xl font-black" data-id="element-212" data-mp="1x8x1n7bwzvln">
              Dejá de improvisar. Empezá a trabajar con un sistema.
            </h3>
            <p className="mt-4 text-sm leading-relaxed text-gray-600" data-id="element-213" data-mp="1s8919v1sq2er">
              Sumate a las esteticistas que ya aplican protocolos profesionales,
              cobran lo que valen y tienen clientas que vuelven sesión tras
              sesión.
            </p>
            <p className="mt-5 text-xs font-black tracking-[0.14em] text-brand-600" data-id="element-214" data-mp="2fzekmk6y3ctt">
              PROTOCOLOS. MAPAS. FICHAS. CHECKLISTS. GUÍAS. TODO RESUELTO.
            </p>
            <div className="mt-6 overflow-x-auto rounded-xl border border-brand-100 text-left" data-id="element-215" data-mp="2px2mrv6vrmm0">
              <table className="min-w-[620px] w-full text-sm" data-id="element-216" data-mp="2kyhpa3j0jh19">
                <thead data-id="element-217" data-mp="2l02f5fudubss">
                  <tr className="bg-cream" data-id="element-218" data-mp="3saowkd9zu57v">
                    <th className="p-4 text-gray-600" data-id="element-219" data-mp="3s9x0l1chi5h2">
                      ❌ Sin MegaPack Ventosas Estéticas Pro™
                    </th>
                    <th className="p-4 text-brand-700" data-id="element-220" data-mp="8qr04471iqj">
                      ✅ Con MegaPack Ventosas Estéticas Pro™
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-221" data-mp="a2zhkm9nz1m2">
                  {[['Improvisás zona por zona', 'Protocolo claro para cada zona del cuerpo'], ['Resultados inconsistentes', 'Resultados visibles que tus clientas perciben'], ['Clientas que abandonan', 'Tratamientos que renuevan'], ['Precio que no podés justificar', 'Sistema profesional que habla por vos'], ['Buscando tutoriales en YouTube', '360 páginas de protocolos listos en tu cabina']].map(([without, withSystem]) => <tr key={without} className="border-t border-brand-100" data-id="element-222" data-mp="2dd2rs3qo42su">
                      <td className="p-3.5 text-gray-600" data-id="element-223" data-mp="28ej4o00c8kyw">{without}</td>
                      <td className="p-3.5 font-semibold text-brand-800" data-id="element-224" data-mp="28e9gmhyusnvu">
                        {withSystem}
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
            <p className="mt-7 text-xs font-bold tracking-wider text-brand-600" data-id="element-225" data-mp="1uml3cbcvbtda">
              ⏰ EL PRECIO CIERRA EN: {clock}
            </p>
            <p className="mt-2 text-base font-bold" data-id="element-226" data-mp="1ppkyu4vo2yoa">
              MEGAPACK VENTOSAS ESTÉTICAS PRO™ — $14 USD ⭐
            </p>
            <a href={CHECKOUT_URL} className="mt-6 block rounded-xl bg-brand-600 px-5 py-4 text-sm font-extrabold text-white transition-colors hover:bg-brand-700" data-id="element-227" data-mp="1kqrje6wtkxlh">
              SÍ, QUIERO MI MEGAPACK AHORA
            </a>
            <p className="mt-4 text-xs text-gray-500" data-id="element-228" data-mp="m3ldbtd4nzz">
              🔒 Pago 100% seguro · ⚡ Acceso inmediato · 🛡️ Garantía de 7 días
            </p>
          </div>
        </div>
      </section>

      <footer className="bg-[#102015] px-4 py-10 text-center text-sm text-gray-400 sm:px-6" data-id="element-229" data-mp="3noqc4hicwf2d">
        <div className="mx-auto max-w-4xl" data-id="element-230" data-mp="3irgliyj8dxcy">
          <p className="font-bold text-white" data-id="element-231" data-mp="3is9p5qmw86qv">
            MEGAPACK VENTOSAS ESTÉTICAS PRO™
          </p>
          <p className="mx-auto mt-3 max-w-xl leading-relaxed" data-id="element-232" data-mp="390lqb4o0bnfd">
            El sistema #1 de protocolos de ventosas estéticas en español. Porque
            una esteticista profesional no debería improvisar nunca más.
          </p>
          <div className="mt-7 flex flex-wrap justify-center gap-x-6 gap-y-3" data-id="element-233" data-mp="300748337y4at">
            <a href="mailto:soporte@tuproximonivel.com" className="flex items-center gap-2 hover:text-white" data-id="element-234" data-mp="2v14ahesovki5">
              <MailIcon className="h-4 w-4" data-id="element-235" data-mp="1aiaa67pdba3h" />
              soporte@tuproximonivel.com
            </a>
            <a href="https://www.instagram.com/tuproximonivel216/" target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-white" data-id="element-236" data-mp="1fg1y6qmw6c2e">
              <InstagramIcon className="h-4 w-4" data-id="element-237" data-mp="1og8j2xkx6ebl" />
              @tuproximonivel
            </a>
            <a href="https://www.facebook.com/profile.php?id=61555374626740" target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-white" data-id="element-238" data-mp="rqheu6mttcsl">
              <FacebookIcon className="h-4 w-4" data-id="element-239" data-mp="15k8kv51cmejk" />
              Facebook
            </a>
          </div>
          <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs" data-id="element-240" data-mp="92m6x3dwat7e">
            <a href="#terms" className="hover:text-white" data-id="element-241" data-mp="d2wak9e7t7j3">
              Términos y condiciones
            </a>
            <a href="#privacy" className="hover:text-white" data-id="element-242" data-mp="1gdjv2ir5sy83">
              Política de privacidad
            </a>
          </div>
          <p className="mt-7 text-xs" data-id="element-243" data-mp="1bepelngnzlr5">
            TU PRÓXIMO NIVEL™ — Todos los derechos reservados.
          </p>
        </div>
      </footer>
    </div>;
}